export default __webpack_public_path__ + "static/media/k15.a1a08028.jpg";